import React from "react";

import { PRESS_LABEL_INFO_LIST } from "@constants/labels.constants";

import * as S from "./PressLabelInfoList.style";

interface Props {
  title?: string;
}

const PressLabelInfoList = ({ title }: Props) => {
  return (
    <S.PressLabelInfoListWrapper>
      {title && <S.Title>{title}</S.Title>}
      <S.PressLabelInfoList>
        {PRESS_LABEL_INFO_LIST.map((item) => (
          <React.Fragment key={item.id}>
            <S.PressLabelInfo
              key={item.id}
              code={item.code}
              background={item.background}
              border={item.border}
            >
              {item.value}
            </S.PressLabelInfo>
          </React.Fragment>
        ))}
      </S.PressLabelInfoList>
    </S.PressLabelInfoListWrapper>
  );
};

export default PressLabelInfoList;
